<template>

  <div class="Fuell-Table--row">
    <div
      class="Fuell-Table--item"
      v-tooltip="customer && customer.name ? customer.name : ''"
      @click="showActionsModal"
    >
      <div class="Thumb Thumb--32 mr-2 bg-secondary text-white">
        {{ customer.name | extractInitialsByName }}
      </div>
      <span class="clickable dark">
        {{ customer && customer.name ? customer.name : "" }}
      </span>
    </div>
    <div class="Fuell-Table--item">
      <div class="Fuell-Table--item">
        <span class="ellipsis black">{{
          customer && customer.registrationNumber
            ? customer.registrationNumber
            : ""
        }}</span>
      </div>
    </div>
    <div
      class="Fuell-Table--item"
      @click="showActionsModal"
    >
      <span class="Fuell-Text">{{customerOnboardingType}}</span>
    </div>
    <div
      class="Fuell-Table--item"
      @click="showActionsModal"
    >
      <span :class="{
          'status--green': canBeArchived,
          'status--red': !canBeArchived,
        }">
        {{
          customer && customer.customerStatus
            ? $t(`customer_status__${customer.customerStatus.code}`)
            : ""
        }}
      </span>
    </div>
    <div
      class="Fuell-Table--item"
      @click="showActionsModal"
    >
      <select
        class="Select Select-ctrl Select--table Fuell-Text"
        @change="setCustomerType"
      >
        <option
          v-for="customerType in customerTypes"
          :value="customerType.id"
          :selected="customerType.id === customer.customerType.id"
          :key="customerType.id"
        >{{customerType.name}} - Coste: {{$options.filters.currency(customerType.costPerCard, '€', 2,
            {
              symbolOnLeft: false,
              thousandsSeparator: '.',
              decimalSeparator: ','
            }
          )}}</option>
      </select>
    </div>
    <div
      class="Fuell-Table--item"
      @click="showActionsModal"
    >
      {{ customerCardUsageType }}
    </div>
    <div
      class="Fuell-Table--item dark"
      v-tooltip="`${fullCustomerName}`"
      @click="showActionsModal"
    >
      <div class="Thumb Thumb--32 mr-2 bg-secondary text-white">
        {{ `${fullCustomerName}` | extractInitialsByName }}
      </div>
      <span class="Itm-name u-black"> {{ fullCustomerName }}</span>
    </div>
    <div
      class="Fuell-Table--item"
      @click="showActionsModal"
    >
      <template v-if="adminStatus">
        <span
          class="Itm-name"
          :class="adminStatusClass"
        >
          {{ $t(`user_status__${adminStatus.statusType.code}`) }}</span>
      </template>
    </div>
    <div class="Fuell-Table--item Fuell-Table--options Fuell-Dropdown--button-dots">
      <template v-if="adminStatus">
        <button
          @click="showActionsModal"
          class="Fuell-IconButton Fuell-IconButton--no-margin dots"
        >
          <img
            :src="require(`@/assets/img/icons/icon-dots.svg`)"
            alt="options"
          />
        </button>
      </template>
    </div>
  </div>
</template>

<script>
import { CUSTOMER_CREATION_TYPES } from '../../_constants/constants'
export default {
  name: 'UserCustomerListTableRow',

  props: {
    customer: {
      type: Object,
      required: true
    }
  },
  computed: {
    customerOffice () {
      return this.customer &&
        this.customer.offices &&
        this.customer.offices.length > 0
        ? this.customer.offices[0]
        : false
    },
    customerOfficeAdmin () {
      return this.customerOffice ? this.customer.offices[0].admin : false
    },
    fullCustomerName () {
      let fullCustomerName = ''

      if (this.customerOfficeAdmin && this.customerOfficeAdmin.firstName) {
        fullCustomerName += this.customerOfficeAdmin.firstName
      }
      if (this.customerOfficeAdmin && this.customerOfficeAdmin.lastName) {
        fullCustomerName += ' ' + this.customerOfficeAdmin.lastName
      }
      return fullCustomerName
    },
    customerTypes () {
      return (
        this.$store.getters['ConfigStore/zohoPlans'].customer_types || []
      )
    },
    canBeArchived () {
      return (
        this.customer &&
        this.customer.customerStatus &&
        this.customer.customerStatus.code === 'ACTIVE'
      )
    },
    adminStatus () {
      return this.customerOfficeAdmin && this.customerOfficeAdmin.status
    },
    adminStatusClass () {
      if (
        this.adminStatus &&
        ['INVITE_BY_SUPER_ADMIN', 'INVITE_BY_ADMIN'].includes(
          this.adminStatus.statusType.code
        )
      ) {
        return 'status--pending'
      }
      if (this.adminStatus && this.adminStatus.statusType.code === 'ACTIVE') {
        return 'status--active'
      }
      if (this.adminStatus && this.adminStatus.statusType.code === 'ARCHIVE') {
        return 'status--expired'
      }
      return 'u-black'
    },
    customerCardUsageType () {
      return this.customer &&
        this.customer.offices[0] &&
        this.customer.offices[0].officeCardsType
        ? this.$t(
          `office_card_usage_type__${this.customer.offices[0].officeCardsType}`
        )
        : ''
    },
    canBeSuppplanted () {
      return (
        this.adminStatus &&
        this.adminStatus.active &&
        this.adminStatus.statusType.code === 'ACTIVE'
      )
    },
    customerPricingPlan () {
      return this.customer &&
        this.customer.customerType &&
        this.customer.customerType.name
        ? `${this.customer.customerType.name
        } - Coste: ${this.$options.filters.currency(this.customer.customerType.costPerCard, '€', 2,
          {
            symbolOnLeft: false,
            thousandsSeparator: '.',
            decimalSeparator: ','
          }
        )}`
        : ''
    },
    customerOnboardingType () {
      if (this.customer?.creationType.code === CUSTOMER_CREATION_TYPES.STANDARD) {
        return this.$t('customer_onboarding_type__STANDARD')
      }
      if (this.customer?.creationType.code === CUSTOMER_CREATION_TYPES.SELF_ONBOARD) {
        return this.$t('customer_onboarding_type__SELF_ONBOARD')
      }

      if (this.customer?.creationType.code === CUSTOMER_CREATION_TYPES.WITHOUT_CUSTOMER) {
        return this.$t('customer_onboarding_type__WITHOUT_CUSTOMER')
      }
      return ''
    }
  },
  data () {
    return {
      editFlag: false,
      showActionsDropDownFlag: false,
      updatedCustomerName: this.customer.name,
      updatedCustomerType: null
    }
  },
  methods: {
    editCustomer () {
      this.editFlag = !this.editFlag
    },
    setCustomerType (event) {
      if (event && event.target && event.target.value) {
        this.updatedCustomerType = { id: event.target.value }
      } else {
        this.updatedCustomerType = { id: event }
      }
      this.saveCustomer()
    },
    async saveCustomer () {
      const customerUpdatedData = {
        id: this.customer.id,
        name: this.updatedCustomerName,
        customerType: this.updatedCustomerType || this.customer.customerType
      }
      await this.$store.dispatch(
        'CustomersStore/updateCustomer',
        customerUpdatedData
      )
      this.editFlag = false
    },
    showActionsModal () {
      this.$emit('showCustomerActionsModal', this.customer)
    },
    generateCustomerLabelPricing ({ name, costPerCard }) {
      return `${name} - Coste: ${this.$options.filters.currency(
        costPerCard,
        '€',
        2,
        { symbolOnLeft: false, thousandsSeparator: '.', decimalSeparator: ',' }
      )}`
    }
  }
}
</script>

<style scoped>
.Select-ctrl {
  appearance: auto;
}
</style>
